export default __webpack_public_path__ + "static/media/standard-layout.484eae91.png";